<template>
    <section class="section section-lg">
        <div class="container">
            <div class="row row-grid justify-content-center">
                <div class="col-lg-8 text-center">
                    <h2 class="display-3">A little About Us
                        <span class="text-success">Who we are?</span>
                    </h2>
                    <p class="lead">We are FollowMeTraveller, as name implies a Tours & Travels Management company specialising in allowing you to build your own package.</p>
                    <div class="btn-wrapper">
                        <a href="#" class="btn btn-primary mb-3 mb-sm-0">Know more</a>
                    </div>
              
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
</style>
